import Sync from './index.vue'

export default [
  { path: '/sync', component: Sync, meta: { auth: true } },
]